import dayjs from 'dayjs';

export const money = (value, digits = 2) =>
  value === null || value === undefined
    ? '—'
    : Number(value).toLocaleString('sr-RS', {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
      });

export const date = (value) =>
  value ? dayjs(value).format('DD.MM.YYYY') : '—';

export const FINAL_QUARTER = 5;
export const QUARTERS = [1, 2, 3, 4, FINAL_QUARTER];

/**
 * When NBS expects the form: ten days after the quarter, and the final
 * version of the last quarter by 31 March of the next year.
 */
export const deadlineOf = (year, quarter) => {
  if (quarter === FINAL_QUARTER) return dayjs(`${year + 1}-03-31`);
  if (quarter === 4) return dayjs(`${year + 1}-01-10`);
  return dayjs(`${year}-${String(quarter * 3 + 1).padStart(2, '0')}-10`);
};

/** The period whose form is due next: the quarter that ended last. */
export const currentPeriod = () => {
  const now = dayjs();
  const q = Math.floor(now.month() / 3); // quarters fully behind us this year
  return q === 0
    ? { year: now.year() - 1, quarter: 4 }
    : { year: now.year(), quarter: q };
};

export const STATUS_COLORS = {
  READY: 'green',
  INCOMPLETE: 'orange',
  MANUAL: 'purple',
  SENT: 'blue',
};

export const TABLE4_FIELDS = [
  'f30',
  'f31',
  'f320',
  'f321',
  'f33',
  'f340',
  'f341',
];

export const ENTITY_TYPES = [11, 12, 13, 14, 15, 21, 22, 23, 24, 25, 26];
export const INVESTMENT_TYPES = [10, 20, 30, 40];
export const OWNER_TYPES = [51, 52, 53, 54, 55];
export const EQUITY_TYPES = [10, 20, 30, 40, 50, 60, 70];
export const PAYMENT_METHODS = [10, 20, 30, 40, 50, 60, 70];

export const saveBlob = (blob, fileName) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

/** The server's message for a failed request; a blob error body is read as text. */
export const errorText = async (error) => {
  const data = error?.response?.data;
  if (data instanceof Blob) {
    try {
      const parsed = JSON.parse(await data.text());
      return parsed?.message || error.message;
    } catch {
      return error.message;
    }
  }
  return data?.message || error?.message || '';
};
